import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Button, Input, Table, Spin, Divider } from 'antd';
import axios from "axios";
import {USER_SERVER} from '../../../config'
function ShowResult() {

    const [Reservations, setReservations] = useState([]);

    useEffect(() => {
        get_reservations();
    }, []);

    async function get_reservations() {
        try {
            const res = await axios.post(`${USER_SERVER}/reservation/get_reservations`, {});

            console.log('get_reservations--------->', res);
            if (res.data?.success) {
                setReservations(res.data.data);
            }
        } catch (error) {
            console.error('Failed to fetch reservations:', error);
            // 서버 연결 실패 시 기본 동작 설정
            setReservations([]);
        }
    }

    async function delete_reservation(reservation_id) {
        try {
            const res = await axios.post(`${USER_SERVER}/reservation/delete_reservation`, {reservation_id: reservation_id});
            console.log('delete_reservation--------->', res);
            if (res.data?.success) {
                get_reservations();
            }
        } catch (error) {
            console.error('Failed to delete reservation:', error);
        }
    }

    console.log('Reservations', Reservations);
    const render_agsinfo = Reservations  && Reservations.map(function(ags, index){
    const extra_request = ags.extra_request || 'No request';
    return (
        <tr key={index}>
            <td>{index+1}</td>
            <td>{ags.name}</td>
            <td>{ags.date}</td>
            <td>{ags.time}</td>
            <td>{ags.party_size}</td>
            <td>{extra_request}</td>
            <td><Button onClick={() => delete_reservation(ags.reservation_id)}>Delete</Button></td>
        </tr>
    );
    });      

    return (
        <div style={{textAlign:'center'}}>
            <h3>Reservations</h3> 

            <Row justify='center'>
                <Col span={12}>
                    <table>
                        <thead>
                            <tr>
                                <th>Item</th>
                                <th>Name</th>
                                <th>Date</th>
                                <th>Time</th>
                                <th>Party Size</th>
                                <th>Request</th>
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            {render_agsinfo || <tr><td colSpan="6">No reservations available</td></tr>}
                        </tbody>
                    </table>
                </Col>
            </Row>

        </div>
    )
}

export default ShowResult
